<template>
  <div>
    <input
      type="checkbox"
      :id="id"
      :name="name"
      :value="value"
      v-on:change="onValueChange(data)"
      :checked="isChecked"
    />
    <label :for="id">{{ labelText }}</label>
  </div>
</template>

<script>
export default {
  name: 'CheckBox',
  props: [
    'id',
    'value',
    'name',
    'onValueChange',
    'data',
    'isChecked',
    'labelText'
  ]
}
</script>

<style lang="scss" scoped>
div {
  display: flex;
}
input[type='checkbox'] {
  display: none;
}
label {
  cursor: pointer;
  display: inline-block;
  position: relative;
  padding-left: 23px;
  font-size: 14px;
  line-height: 24px;
  color: $grey-color;

  &::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 2px;
    width: 18px;
    height: 18px;
    padding: 0px 2px;
    border-radius: 4px;
    background: #ffffff;
    border: 1px solid rgba(102, 112, 128, 0.2);
  }
}
input[type='checkbox']:checked + label::before {
  background: rgba(38, 72, 247, 0.12);
  border: 1px solid #2648f7;
  content: '\2713';
  color: #2648f7;
  font-size: 12px;
  display: flex;
  align-items: center;
}
</style>
